var _g, _path, _path2, _path3, _path4, _g2, _g3, _g4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThrivveLogoAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 36,
    viewBox: "0 0 150 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M83.0514 7.80615H77.9111V29.2574H83.0514V7.80615Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M102.097 12.5879V21.2834C102.097 23.0995 100.624 24.5717 98.8082 24.5717H94.3879V12.5879H89.2477V27.9586C89.2477 30.0039 88.225 30.946 86.982 30.946C86.2083 30.946 86.0184 30.9675 85.0244 30.912L85.0513 35.3699C85.7695 35.5364 86.5987 35.6188 87.428 35.6188C91.4345 35.6188 93.7808 33.9818 94.2787 29.2571H97.1802H98.3443C103.271 29.2571 107.267 25.2631 107.267 20.3341V12.5879H102.1H102.097Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M69.041 12.5894V19.6604C69.041 22.3756 66.8434 24.5768 64.13 24.5839L59.5664 24.5947V29.2585H64.0494C69.6607 29.2585 74.2099 24.7093 74.2099 19.098V12.5894H69.041Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M59.9555 29.2588V24.5967L52.1144 24.6129H51.029V20.8087C51.029 19.8702 50.8929 17.7425 49.4618 15.7454C49.1269 15.2762 48.3819 14.2893 47.0422 13.5264C45.466 12.629 43.9634 12.6434 43.1413 12.6523C42.2565 12.6613 38.592 12.7007 36.3085 15.5843C36.3085 15.5843 34.6536 17.6708 34.641 20.7263C34.6356 21.9908 34.9688 23.1908 34.9867 23.2463C35.1389 23.7299 35.3109 24.1848 35.5007 24.6129H24.1061C23.9557 24.6129 23.816 24.6218 23.6817 24.6379H10.5713V29.2588H31.684H52.2648H59.9555ZM46.8416 24.6111H43.324C42.9783 24.6415 41.1837 24.7687 39.9801 23.5347C38.2804 21.792 38.8732 18.4804 40.5676 17.3216C41.4488 16.7198 42.604 16.7162 42.8762 16.7162C43.6696 16.7162 44.3287 16.8684 44.8338 17.1675C45.4875 17.5562 45.8457 18.0487 46.0445 18.3371C46.7341 19.3436 46.8344 20.395 46.8416 20.9287V24.6075V24.6111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M103.425 8.86839C103.425 10.1436 104.326 10.7597 105.343 10.7597C106.36 10.7597 107.259 10.1436 107.259 8.86839C107.259 7.70064 106.436 6.95557 105.343 6.95557C104.25 6.95557 103.425 7.69885 103.425 8.86839Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M101.099 10.7597C102.097 10.7597 103.017 10.1436 103.017 8.86839C103.017 7.70064 102.174 6.95557 101.099 6.95557C100.024 6.95557 99.1826 7.69885 99.1826 8.86839C99.1826 10.1436 100.084 10.7597 101.099 10.7597Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M103.084 6.95553C104.082 6.95553 105.001 6.33941 105.001 5.06419C105.001 3.89644 104.177 3.15137 103.084 3.15137C101.992 3.15137 101.166 3.89465 101.166 5.06419C101.166 6.33941 102.067 6.95553 103.084 6.95553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M43.1055 8.86839C43.1055 10.1436 44.0064 10.7597 45.0237 10.7597C46.041 10.7597 46.9401 10.1436 46.9401 8.86839C46.9401 7.70064 46.1162 6.95557 45.0237 6.95557C43.9311 6.95557 43.1055 7.69885 43.1055 8.86839Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M40.7797 10.7597C41.7773 10.7597 42.6979 10.1436 42.6979 8.86839C42.6979 7.70064 41.8543 6.95557 40.7797 6.95557C39.7051 6.95557 38.8633 7.69885 38.8633 8.86839C38.8633 10.1436 39.7642 10.7597 40.7797 10.7597Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M70.6465 32.6994C70.6465 33.9747 71.5474 34.5908 72.5647 34.5908C73.582 34.5908 74.4811 33.9747 74.4811 32.6994C74.4811 31.5317 73.6572 30.7866 72.5647 30.7866C71.4722 30.7866 70.6465 31.5299 70.6465 32.6994Z",
    fill: "#F7971D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M68.3217 34.5908C69.3193 34.5908 70.2399 33.9747 70.2399 32.6994C70.2399 31.5317 69.3963 30.7866 68.3217 30.7866C67.2471 30.7866 66.4053 31.5299 66.4053 32.6994C66.4053 33.9747 67.3062 34.5908 68.3217 34.5908Z",
    fill: "#F7971D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M42.7649 6.95553C43.7625 6.95553 44.6813 6.33941 44.6813 5.06419C44.6813 3.89644 43.8574 3.15137 42.7649 3.15137C41.6723 3.15137 40.8467 3.89465 40.8467 5.06419C40.8467 6.33941 41.7476 6.95553 42.7649 6.95553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M12.6678 28.6229C12.5622 28.2002 12.5102 27.6235 12.5102 26.8963C12.5102 26.2157 12.5622 25.6695 12.6678 25.2575C12.7735 24.8456 12.9562 24.6396 13.2141 24.6396H10.5347C9.10188 24.6396 7.89651 24.4408 6.92219 24.0396C5.94608 23.6402 5.20638 23.0474 4.70131 22.2593C4.19623 21.4731 3.9437 20.5023 3.9437 19.3507C3.9437 18.645 4.04937 17.882 4.26071 17.0599C4.47205 16.2379 4.8016 15.38 5.24757 14.488L2.0058 13.0068C1.32341 14.0403 0.818341 15.14 0.490582 16.3023C0.161031 17.4647 -0.00195312 18.6235 -0.00195312 19.7734C-0.00195312 21.0199 0.204016 22.2056 0.614163 23.3339C1.02431 24.4623 1.6655 25.4724 2.53594 26.3662C3.4046 27.2599 4.50967 27.9638 5.84936 28.4814C7.18906 28.999 8.76338 29.2569 10.5723 29.2569H13.2159C12.958 29.2569 12.7753 29.0456 12.6696 28.6229H12.6678Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M145.748 29.8855C143.875 31.3273 142.003 32.7691 140.13 34.2108C139.829 34.4437 139.399 34.3882 139.164 34.0873C137.782 32.3106 136.988 30.9941 135.537 29.1655C135.186 28.6676 134.529 27.5715 134.536 26.0992C134.551 23.5739 136.513 22.0426 136.865 21.7685C137.927 20.9375 139.025 20.6563 139.637 20.5488C141.958 23.5291 143.595 25.9739 145.872 28.9183C146.104 29.2192 146.049 29.6545 145.748 29.8855Z",
    fill: "#FBB333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M139.638 20.5479C139.027 20.6571 137.93 20.9383 136.866 21.7693C136.516 22.0416 134.553 23.5747 134.539 26.1001C134.53 27.5723 135.189 28.6684 135.539 29.1663C136.991 30.995 137.785 32.3132 139.167 34.0881C139.4 34.3872 139.832 34.4445 140.133 34.2117C142.004 32.7699 143.878 31.3281 145.751 29.8863C146.052 29.6553 146.107 29.2183 145.875 28.9192C143.598 25.9747 141.961 23.5281 139.64 20.5479",
    fill: "#FBB333"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M127.856 30.6953L127.827 30.736H127.82L127.856 30.6953Z",
    fill: "#19114A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M149.64 16.8476L144.697 18.4381C143.917 18.6852 143.242 18.7927 142.737 18.8429C142.237 18.893 141.781 18.8966 141.385 18.8787C141.365 18.8787 141.345 18.8787 141.326 18.8787C141.182 18.8697 141.046 18.8608 140.921 18.8482C140.432 18.8017 140.085 18.73 139.922 18.6942C139.828 18.6745 139.737 18.653 139.648 18.6279C137.532 18.0817 136.11 16.8441 135.38 16.2065C135.328 16.1617 135.274 16.1133 135.224 16.0703C135.014 15.8715 134.808 15.6691 134.604 15.4685C134.593 15.4578 134.586 15.4506 134.579 15.4435C134.514 15.3826 134.448 15.3217 134.387 15.2608C133.053 13.9659 131.724 12.6745 130.399 11.3635C128.742 9.72111 127.812 7.48411 127.821 5.15397C127.825 3.71577 127.832 2.26861 127.834 0.891305C127.834 0.60653 128.065 0.380859 128.346 0.380859L136.185 0.409516C136.468 0.409516 136.698 0.64056 136.694 0.921752C136.691 2.52831 136.683 4.13308 136.682 5.74143C136.676 7.03993 136.671 8.33843 136.665 9.63693V9.7032C136.662 10.3623 136.66 11.0232 136.657 11.6841V11.7127C136.657 11.7127 136.662 11.7127 136.665 11.7092C140.088 10.613 143.509 9.51335 146.93 8.41545C147.199 8.32948 147.487 8.47634 147.575 8.745L149.973 16.21C150.059 16.4805 149.912 16.7688 149.64 16.853V16.8476Z",
    fill: "#FBB333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1801_1251",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 136,
    y: 8,
    width: 14,
    height: 11
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M149.635 16.8464L144.691 18.4351C143.912 18.684 143.237 18.7897 142.734 18.8398C142.234 18.89 141.777 18.8936 141.382 18.8756C141.362 18.8756 141.342 18.8739 141.322 18.8739C138.722 18.3742 136.635 16.087 136.651 13.1891C136.651 13.1587 136.671 12.6249 136.659 11.9031C136.657 11.8369 136.655 11.7796 136.655 11.7384V11.7043C140.08 10.6064 143.502 9.50674 146.928 8.40883C147.197 8.32286 147.484 8.46973 147.571 8.73838L149.97 16.2034C150.056 16.4739 149.909 16.7622 149.636 16.8464",
    fill: "black"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1801_1251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M149.238 5.09805L134.104 8.96973L137.466 22.1135L152.6 18.2418L149.238 5.09805Z",
    fill: "url(#paint0_linear_1801_1251)"
  })))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M125.075 20.0805L125.068 20.1017L125.038 20.0929L125.056 20.0664L125.059 20.0699L125.075 20.0805Z",
    fill: "#02AFBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M125.059 20.0699L125.075 20.0805L125.068 20.1017L125.038 20.0929L125.056 20.0664L125.059 20.0699Z",
    fill: "#02AFBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M125.071 20.0808L125.066 20.1029C125.062 20.09 125.06 20.0808 125.057 20.0679L125.071 20.0808Z",
    fill: "#02AFBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M117.856 8.27531L122.752 10.0019C123.523 10.2759 124.124 10.5983 124.556 10.8634C124.984 11.1266 125.349 11.3989 125.654 11.6532C125.67 11.6657 125.684 11.6783 125.7 11.6908C126.236 12.1422 126.571 12.5272 126.707 12.6848C126.77 12.7565 126.829 12.8299 126.886 12.9033C128.24 14.6174 128.622 16.4639 128.819 17.4114C128.833 17.4794 128.845 17.5493 128.86 17.6156C128.86 17.6156 128.86 17.6156 128.86 17.6174C128.905 17.9039 128.948 18.1887 128.989 18.4717C128.992 18.486 128.992 18.4968 128.994 18.5075C129.008 18.5935 129.023 18.6812 129.035 18.769C129.315 20.6066 129.591 22.4388 129.854 24.2854C130.18 26.5958 129.565 28.9385 128.149 30.7886C127.277 31.9313 126.395 33.0794 125.559 34.1737C125.387 34.3994 125.066 34.4406 124.843 34.2704L118.619 29.5063C118.393 29.3343 118.35 29.0137 118.522 28.7898C119.496 27.5128 120.474 26.2376 121.45 24.9606C122.654 23.3899 123.859 21.8173 125.063 20.2448L125.079 20.2233C121.688 19.0251 118.296 17.8305 114.906 16.6323C114.641 16.5374 114.501 16.2472 114.592 15.9803L117.2 8.58516C117.295 8.3183 117.587 8.1786 117.856 8.27531Z",
    fill: "#FBB333"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M149.642 16.848L144.699 18.4385C143.92 18.6856 143.245 18.7931 142.74 18.8432C142.24 18.8934 141.783 18.897 141.387 18.8791C141.368 18.8791 141.348 18.8791 141.328 18.8791C141.185 18.8701 141.049 18.8612 140.923 18.8486C138.527 18.168 136.668 15.9722 136.668 13.2248V11.706C140.091 10.6099 143.512 9.51016 146.932 8.41225C147.201 8.32628 147.489 8.47315 147.577 8.7418L149.975 16.2068C150.061 16.4773 149.914 16.7656 149.642 16.8498V16.848Z",
    fill: "url(#paint1_linear_1801_1251)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M145.753 29.884C143.88 31.3258 142.008 32.7676 140.134 34.2094C139.834 34.4422 139.404 34.3867 139.169 34.0858C137.786 32.3091 136.993 30.9927 135.542 29.164C135.191 28.6661 134.534 27.57 134.541 26.0978C134.555 23.5724 136.518 22.0411 136.869 21.7671C137.932 20.936 139.029 20.6548 139.642 20.5474C141.963 23.5276 143.6 25.9724 145.877 28.9169C146.109 29.2178 146.054 29.653 145.753 29.884Z",
    fill: "url(#paint2_linear_1801_1251)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M117.848 8.27754L122.747 10.0005C123.517 10.2745 124.119 10.5969 124.55 10.8638C124.978 11.1271 125.346 11.3993 125.65 11.6519C125.666 11.6644 125.68 11.6769 125.697 11.6895C125.806 11.7826 125.908 11.8722 126.001 11.9581C127.497 13.9498 127.652 16.8226 125.99 19.0112L125.071 20.2202C121.683 19.0238 118.292 17.8309 114.906 16.6363C114.64 16.5414 114.499 16.2512 114.592 15.9844L117.196 8.58918C117.291 8.32232 117.583 8.18083 117.85 8.27754H117.848Z",
    fill: "url(#paint3_linear_1801_1251)"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1801_1251",
    x1: 139.245,
    y1: 13.3127,
    x2: 156.113,
    y2: 8.99733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05182C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20B9C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1801_1251",
    x1: 136.668,
    y1: 13.6367,
    x2: 149.999,
    y2: 13.6367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7971D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1801_1251",
    x1: 133.474,
    y1: 19.1217,
    x2: 144.275,
    y2: 33.9264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7971D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1801_1251",
    x1: 126.281,
    y1: 18.5977,
    x2: 115.664,
    y2: 10.5362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7971D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrivveLogoAr);
export default __webpack_public_path__ + "static/media/thrivve-logo-ar.5cc3e86bfec5e2bc6e50f0c78e8a6700.svg";
export { ForwardRef as ReactComponent };